import { IConstDict } from '@lib/interfaces';

export const countries: Array<IConstDict> = [
    { key: 'ABW', value: 'Aruba' },
    { key: 'AFG', value: 'Afghanistan' },
    { key: 'AGO', value: 'Angola' },
    { key: 'AIA', value: 'Anguilla' },
    { key: 'ALA', value: 'Åland Islands' },
    { key: 'ALB', value: 'Albania' },
    { key: 'AND', value: 'Andorra' },
    { key: 'ARE', value: 'United Arab Emirates' },
    { key: 'ARG', value: 'Argentina' },
    { key: 'ARM', value: 'Armenia' },
    { key: 'ASM', value: 'American Samoa' },
    { key: 'ATA', value: 'Antarctica' },
    { key: 'ATF', value: 'French Southern Territories' },
    { key: 'ATG', value: 'Antigua and Barbuda' },
    { key: 'AUS', value: 'Australia' },
    { key: 'AUT', value: 'Austria' },
    { key: 'AZE', value: 'Azerbaijan' },
    { key: 'BDI', value: 'Burundi' },
    { key: 'BEL', value: 'Belgium' },
    { key: 'BEN', value: 'Benin' },
    { key: 'BES', value: 'Bonaire, Sint Eustatius and Saba' },
    { key: 'BFA', value: 'Burkina Faso' },
    { key: 'BGD', value: 'Bangladesh' },
    { key: 'BGR', value: 'Bulgaria' },
    { key: 'BHR', value: 'Bahrain' },
    { key: 'BHS', value: 'Bahamas' },
    { key: 'BIH', value: 'Bosnia and Herzegovina' },
    { key: 'BLM', value: 'Saint Barthélemy' },
    { key: 'BLR', value: 'Belarus' },
    { key: 'BLZ', value: 'Belize' },
    { key: 'BMU', value: 'Bermuda' },
    { key: 'BOL', value: 'Bolivia (Plurinational State of)' },
    { key: 'BRA', value: 'Brazil' },
    { key: 'BRB', value: 'Barbados' },
    { key: 'BRN', value: 'Brunei Darussalam' },
    { key: 'BTN', value: 'Bhutan' },
    { key: 'BVT', value: 'Bouvet Island' },
    { key: 'BWA', value: 'Botswana' },
    { key: 'CAF', value: 'Central African Republic' },
    { key: 'CAN', value: 'Canada' },
    { key: 'CCK', value: 'Cocos (Keeling) Islands' },
    { key: 'CHE', value: 'Switzerland' },
    { key: 'CHL', value: 'Chile' },
    { key: 'CHN', value: 'China' },
    { key: 'CIV', value: "Côte d'Ivoire" },
    { key: 'CMR', value: 'Cameroon' },
    { key: 'COD', value: 'Congo, Democratic Republic of the' },
    { key: 'COG', value: 'Congo' },
    { key: 'COK', value: 'Cook Islands' },
    { key: 'COL', value: 'Colombia' },
    { key: 'COM', value: 'Comoros' },
    { key: 'CPV', value: 'Cabo Verde' },
    { key: 'CRI', value: 'Costa Rica' },
    { key: 'CUB', value: 'Cuba' },
    { key: 'CUW', value: 'Curaçao' },
    { key: 'CXR', value: 'Christmas Island' },
    { key: 'CYM', value: 'Cayman Islands' },
    { key: 'CYP', value: 'Cyprus' },
    { key: 'CZE', value: 'Czechia' },
    { key: 'DEU', value: 'Germany' },
    { key: 'DJI', value: 'Djibouti' },
    { key: 'DMA', value: 'Dominica' },
    { key: 'DNK', value: 'Denmark' },
    { key: 'DOM', value: 'Dominican Republic' },
    { key: 'DZA', value: 'Algeria' },
    { key: 'ECU', value: 'Ecuador' },
    { key: 'EGY', value: 'Egypt' },
    { key: 'ERI', value: 'Eritrea' },
    { key: 'ESH', value: 'Western Sahara' },
    { key: 'ESP', value: 'Spain' },
    { key: 'EST', value: 'Estonia' },
    { key: 'ETH', value: 'Ethiopia' },
    { key: 'FIN', value: 'Finland' },
    { key: 'FJI', value: 'Fiji' },
    { key: 'FLK', value: 'Falkland Islands (Malvinas)' },
    { key: 'FRA', value: 'France' },
    { key: 'FRO', value: 'Faroe Islands' },
    { key: 'FSM', value: 'Micronesia (Federated States of)' },
    { key: 'GAB', value: 'Gabon' },
    { key: 'GBR', value: 'United Kingdom of Great Britain and Northern Ireland' },
    { key: 'GEO', value: 'Georgia' },
    { key: 'GGY', value: 'Guernsey' },
    { key: 'GHA', value: 'Ghana' },
    { key: 'GIB', value: 'Gibraltar' },
    { key: 'GIN', value: 'Guinea' },
    { key: 'GLP', value: 'Guadeloupe' },
    { key: 'GMB', value: 'Gambia' },
    { key: 'GNB', value: 'Guinea-Bissau' },
    { key: 'GNQ', value: 'Equatorial Guinea' },
    { key: 'GRC', value: 'Greece' },
    { key: 'GRD', value: 'Grenada' },
    { key: 'GRL', value: 'Greenland' },
    { key: 'GTM', value: 'Guatemala' },
    { key: 'GUF', value: 'French Guiana' },
    { key: 'GUM', value: 'Guam' },
    { key: 'GUY', value: 'Guyana' },
    { key: 'HKG', value: 'Hong Kong' },
    { key: 'HMD', value: 'Heard Island and McDonald Islands' },
    { key: 'HND', value: 'Honduras' },
    { key: 'HRV', value: 'Croatia' },
    { key: 'HTI', value: 'Haiti' },
    { key: 'HUN', value: 'Hungary' },
    { key: 'IDN', value: 'Indonesia' },
    { key: 'IMN', value: 'Isle of Man' },
    { key: 'IND', value: 'India' },
    { key: 'IOT', value: 'British Indian Ocean Territory' },
    { key: 'IRL', value: 'Ireland' },
    { key: 'IRN', value: 'Iran (Islamic Republic of)' },
    { key: 'IRQ', value: 'Iraq' },
    { key: 'ISL', value: 'Iceland' },
    { key: 'ISR', value: 'Israel' },
    { key: 'ITA', value: 'Italy' },
    { key: 'JAM', value: 'Jamaica' },
    { key: 'JEY', value: 'Jersey' },
    { key: 'JOR', value: 'Jordan' },
    { key: 'JPN', value: 'Japan' },
    { key: 'KAZ', value: 'Kazakhstan' },
    { key: 'KEN', value: 'Kenya' },
    { key: 'KGZ', value: 'Kyrgyzstan' },
    { key: 'KHM', value: 'Cambodia' },
    { key: 'KIR', value: 'Kiribati' },
    { key: 'KNA', value: 'Saint Kitts and Nevis' },
    { key: 'KOR', value: 'Korea, Republic of' },
    { key: 'KWT', value: 'Kuwait' },
    { key: 'LAO', value: "Lao People's Democratic Republic" },
    { key: 'LBN', value: 'Lebanon' },
    { key: 'LBR', value: 'Liberia' },
    { key: 'LBY', value: 'Libya' },
    { key: 'LCA', value: 'Saint Lucia' },
    { key: 'LIE', value: 'Liechtenstein' },
    { key: 'LKA', value: 'Sri Lanka' },
    { key: 'LSO', value: 'Lesotho' },
    { key: 'LTU', value: 'Lithuania' },
    { key: 'LUX', value: 'Luxembourg' },
    { key: 'LVA', value: 'Latvia' },
    { key: 'MAC', value: 'Macao' },
    { key: 'MAF', value: 'Saint Martin (French part)' },
    { key: 'MAR', value: 'Morocco' },
    { key: 'MCO', value: 'Monaco' },
    { key: 'MDA', value: 'Moldova, Republic of' },
    { key: 'MDG', value: 'Madagascar' },
    { key: 'MDV', value: 'Maldives' },
    { key: 'MEX', value: 'Mexico' },
    { key: 'MHL', value: 'Marshall Islands' },
    { key: 'MKD', value: 'North Macedonia' },
    { key: 'MLI', value: 'Mali' },
    { key: 'MLT', value: 'Malta' },
    { key: 'MMR', value: 'Myanmar' },
    { key: 'MNE', value: 'Montenegro' },
    { key: 'MNG', value: 'Mongolia' },
    { key: 'MNP', value: 'Northern Mariana Islands' },
    { key: 'MOZ', value: 'Mozambique' },
    { key: 'MRT', value: 'Mauritania' },
    { key: 'MSR', value: 'Montserrat' },
    { key: 'MTQ', value: 'Martinique' },
    { key: 'MUS', value: 'Mauritius' },
    { key: 'MWI', value: 'Malawi' },
    { key: 'MYS', value: 'Malaysia' },
    { key: 'MYT', value: 'Mayotte' },
    { key: 'NAM', value: 'Namibia' },
    { key: 'NCL', value: 'New Caledonia' },
    { key: 'NER', value: 'Niger' },
    { key: 'NFK', value: 'Norfolk Island' },
    { key: 'NGA', value: 'Nigeria' },
    { key: 'NIC', value: 'Nicaragua' },
    { key: 'NIU', value: 'Niue' },
    { key: 'NLD', value: 'Netherlands' },
    { key: 'NOR', value: 'Norway' },
    { key: 'NPL', value: 'Nepal' },
    { key: 'NRU', value: 'Nauru' },
    { key: 'NZL', value: 'New Zealand' },
    { key: 'OMN', value: 'Oman' },
    { key: 'PAK', value: 'Pakistan' },
    { key: 'PAN', value: 'Panama' },
    { key: 'PCN', value: 'Pitcairn' },
    { key: 'PER', value: 'Peru' },
    { key: 'PHL', value: 'Philippines' },
    { key: 'PLW', value: 'Palau' },
    { key: 'PNG', value: 'Papua New Guinea' },
    { key: 'POL', value: 'Poland' },
    { key: 'PRI', value: 'Puerto Rico' },
    { key: 'PRK', value: "Korea (Democratic People's Republic of)" },
    { key: 'PRT', value: 'Portugal' },
    { key: 'PRY', value: 'Paraguay' },
    { key: 'PSE', value: 'Palestine, State of' },
    { key: 'PYF', value: 'French Polynesia' },
    { key: 'QAT', value: 'Qatar' },
    { key: 'REU', value: 'Réunion' },
    { key: 'ROU', value: 'Romania' },
    { key: 'RUS', value: 'Russian Federation' },
    { key: 'RWA', value: 'Rwanda' },
    { key: 'SAU', value: 'Saudi Arabia' },
    { key: 'SDN', value: 'Sudan' },
    { key: 'SEN', value: 'Senegal' },
    { key: 'SGP', value: 'Singapore' },
    { key: 'SGS', value: 'South Georgia and the South Sandwich Islands' },
    { key: 'SHN', value: 'Saint Helena, Ascension and Tristan da Cunha' },
    { key: 'SJM', value: 'Svalbard and Jan Mayen' },
    { key: 'SLB', value: 'Solomon Islands' },
    { key: 'SLE', value: 'Sierra Leone' },
    { key: 'SLV', value: 'El Salvador' },
    { key: 'SMR', value: 'San Marino' },
    { key: 'SOM', value: 'Somalia' },
    { key: 'SPM', value: 'Saint Pierre and Miquelon' },
    { key: 'SRB', value: 'Serbia' },
    { key: 'SSD', value: 'South Sudan' },
    { key: 'STP', value: 'Sao Tome and Principe' },
    { key: 'SUR', value: 'Suriname' },
    { key: 'SVK', value: 'Slovakia' },
    { key: 'SVN', value: 'Slovenia' },
    { key: 'SWE', value: 'Sweden' },
    { key: 'SWZ', value: 'Eswatini' },
    { key: 'SXM', value: 'Sint Maarten (Dutch part)' },
    { key: 'SYC', value: 'Seychelles' },
    { key: 'SYR', value: 'Syrian Arab Republic' },
    { key: 'TCA', value: 'Turks and Caicos Islands' },
    { key: 'TCD', value: 'Chad' },
    { key: 'TGO', value: 'Togo' },
    { key: 'THA', value: 'Thailand' },
    { key: 'TJK', value: 'Tajikistan' },
    { key: 'TKL', value: 'Tokelau' },
    { key: 'TKM', value: 'Turkmenistan' },
    { key: 'TLS', value: 'Timor-Leste' },
    { key: 'TON', value: 'Tonga' },
    { key: 'TTO', value: 'Trinidad and Tobago' },
    { key: 'TUN', value: 'Tunisia' },
    { key: 'TUR', value: 'Turkey' },
    { key: 'TUV', value: 'Tuvalu' },
    { key: 'TWN', value: 'Taiwan, Province of China' },
    { key: 'TZA', value: 'Tanzania, United Republic of' },
    { key: 'UGA', value: 'Uganda' },
    { key: 'UKR', value: 'Ukraine' },
    { key: 'UMI', value: 'United States Minor Outlying Islands' },
    { key: 'URY', value: 'Uruguay' },
    { key: 'USA', value: 'United States of America' },
    { key: 'UZB', value: 'Uzbekistan' },
    { key: 'VAT', value: 'Holy See' },
    { key: 'VCT', value: 'Saint Vincent and the Grenadines' },
    { key: 'VEN', value: 'Venezuela (Bolivarian Republic of)' },
    { key: 'VGB', value: 'Virgin Islands (British)' },
    { key: 'VIR', value: 'Virgin Islands (U.S.)' },
    { key: 'VNM', value: 'Viet Nam' },
    { key: 'VUT', value: 'Vanuatu' },
    { key: 'WLF', value: 'Wallis and Futuna' },
    { key: 'WSM', value: 'Samoa' },
    { key: 'YEM', value: 'Yemen' },
    { key: 'ZAF', value: 'South Africa' },
    { key: 'ZMB', value: 'Zambia' },
    { key: 'ZWE', value: 'Zimbabwe' },
];

export const languages: Array<IConstDict> = [
    { key: 'AA', value: 'Afar' },
    { key: 'AB', value: 'Abkhazian' },
    { key: 'AE', value: 'Avestan' },
    { key: 'AF', value: 'Afrikaans' },
    { key: 'AK', value: 'Akan' },
    { key: 'AM', value: 'Amharic' },
    { key: 'AN', value: 'Aragonese' },
    { key: 'AR', value: 'Arabic' },
    { key: 'AS', value: 'Assamese' },
    { key: 'AV', value: 'Avaric' },
    { key: 'AY', value: 'Aymara' },
    { key: 'AZ', value: 'Azerbaijani' },
    { key: 'BA', value: 'Bashkir' },
    { key: 'BE', value: 'Belarusian' },
    { key: 'BG', value: 'Bulgarian' },
    { key: 'BH', value: 'Bihari languages' },
    { key: 'BI', value: 'Bislama' },
    { key: 'BM', value: 'Bambara' },
    { key: 'BN', value: 'Bengali' },
    { key: 'BO', value: 'Tibetan' },
    { key: 'BR', value: 'Breton' },
    { key: 'BS', value: 'Bosnian' },
    { key: 'CA', value: 'Catalan' },
    { key: 'CE', value: 'Chechen' },
    { key: 'CH', value: 'Chamorro' },
    { key: 'CO', value: 'Corsican' },
    { key: 'CR', value: 'Cree' },
    { key: 'CS', value: 'Czech' },
    { key: 'CU', value: 'Church Slavic' },
    { key: 'CV', value: 'Chuvash' },
    { key: 'CY', value: 'Welsh' },
    { key: 'DA', value: 'Danish' },
    { key: 'DE', value: 'German' },
    { key: 'DV', value: 'Maldivian' },
    { key: 'DZ', value: 'Dzongkha' },
    { key: 'EE', value: 'Ewe' },
    { key: 'EL', value: 'Greek (modern)' },
    { key: 'EN', value: 'English' },
    { key: 'EO', value: 'Esperanto' },
    { key: 'ES', value: 'Spanish' },
    { key: 'ET', value: 'Estonian' },
    { key: 'EU', value: 'Basque' },
    { key: 'FA', value: 'Persian' },
    { key: 'FF', value: 'Fulah' },
    { key: 'FI', value: 'Finnish' },
    { key: 'FJ', value: 'Fijian' },
    { key: 'FO', value: 'Faroese' },
    { key: 'FR', value: 'French' },
    { key: 'FY', value: 'Western Frisian' },
    { key: 'GA', value: 'Irish' },
    { key: 'GD', value: 'Gaelic' },
    { key: 'GL', value: 'Galician' },
    { key: 'GN', value: 'Guaraní' },
    { key: 'GU', value: 'Gujarati' },
    { key: 'GV', value: 'Manx' },
    { key: 'HA', value: 'Hausa' },
    { key: 'HE', value: 'Hebrew (modern)' },
    { key: 'HI', value: 'Hindi' },
    { key: 'HO', value: 'Hiri Motu' },
    { key: 'HR', value: 'Croatian' },
    { key: 'HT', value: 'Haitian Creole' },
    { key: 'HU', value: 'Hungarian' },
    { key: 'HY', value: 'Armenian' },
    { key: 'HZ', value: 'Herero' },
    { key: 'IA', value: 'Interlingua' },
    { key: 'ID', value: 'Indonesian' },
    { key: 'IE', value: 'Interlingue' },
    { key: 'IG', value: 'Igbo' },
    { key: 'II', value: 'Nuosu' },
    { key: 'IK', value: 'Inupiaq' },
    { key: 'IO', value: 'Ido' },
    { key: 'IS', value: 'Icelandic' },
    { key: 'IT', value: 'Italian' },
    { key: 'IU', value: 'Inuktitut' },
    { key: 'JA', value: 'Japanese' },
    { key: 'JV', value: 'Javanese' },
    { key: 'KA', value: 'Georgian' },
    { key: 'KG', value: 'Kongo' },
    { key: 'KI', value: 'Kikuyu' },
    { key: 'KJ', value: 'Kwanyama' },
    { key: 'KK', value: 'Kazakh' },
    { key: 'KL', value: 'Greenlandic' },
    { key: 'KM', value: 'Central Khmer' },
    { key: 'KN', value: 'Kannada' },
    { key: 'KO', value: 'Korean' },
    { key: 'KR', value: 'Kanuri' },
    { key: 'KS', value: 'Kashmiri' },
    { key: 'KU', value: 'Kurdish' },
    { key: 'KV', value: 'Komi' },
    { key: 'KW', value: 'Cornish' },
    { key: 'KY', value: 'Kyrgyz' },
    { key: 'LA', value: 'Latin' },
    { key: 'LB', value: 'Luxembourgish' },
    { key: 'LG', value: 'Ganda' },
    { key: 'LI', value: 'Limburgish' },
    { key: 'LN', value: 'Lingala' },
    { key: 'LO', value: 'Lao' },
    { key: 'LT', value: 'Lithuanian' },
    { key: 'LU', value: 'Luba-Katanga' },
    { key: 'LV', value: 'Latvian' },
    { key: 'MG', value: 'Malagasy' },
    { key: 'MH', value: 'Marshallese' },
    { key: 'MI', value: 'Maori' },
    { key: 'MK', value: 'Macedonian' },
    { key: 'ML', value: 'Malayalam' },
    { key: 'MN', value: 'Mongolian' },
    { key: 'MR', value: 'Marathi' },
    { key: 'MS', value: 'Malay' },
    { key: 'MT', value: 'Maltese' },
    { key: 'MY', value: 'Burmese' },
    { key: 'NA', value: 'Nauru' },
    { key: 'NB', value: 'Bokmål' },
    { key: 'ND', value: 'North Ndebele' },
    { key: 'NE', value: 'Nepali' },
    { key: 'NG', value: 'Ndonga' },
    { key: 'NL', value: 'Dutch' },
    { key: 'NN', value: 'Norwegian Nynorsk' },
    { key: 'NO', value: 'Norwegian' },
    { key: 'NR', value: 'South Ndebele' },
    { key: 'NV', value: 'Navajo' },
    { key: 'NY', value: 'Nyanja' },
    { key: 'OC', value: 'Occitan' },
    { key: 'OJ', value: 'Ojibwa' },
    { key: 'OM', value: 'Oromo' },
    { key: 'OR', value: 'Oriya' },
    { key: 'OS', value: 'Ossetian' },
    { key: 'PA', value: 'Punjabi' },
    { key: 'PI', value: 'Pali' },
    { key: 'PL', value: 'Polish' },
    { key: 'PS', value: 'Pashto' },
    { key: 'PT', value: 'Portuguese' },
    { key: 'QU', value: 'Quechua' },
    { key: 'RM', value: 'Romansh' },
    { key: 'RN', value: 'Rundi' },
    { key: 'RO', value: 'Romanian' },
    { key: 'RU', value: 'Russian' },
    { key: 'RW', value: 'Kinyarwanda' },
    { key: 'SA', value: 'Sanskrit' },
    { key: 'SC', value: 'Sardinian' },
    { key: 'SD', value: 'Sindhi' },
    { key: 'SE', value: 'Northern Sami' },
    { key: 'SG', value: 'Sango' },
    { key: 'SI', value: 'Sinhalese' },
    { key: 'SK', value: 'Slovak' },
    { key: 'SL', value: 'Slovenian' },
    { key: 'SM', value: 'Samoan' },
    { key: 'SN', value: 'Shona' },
    { key: 'SO', value: 'Somali' },
    { key: 'SQ', value: 'Albanian' },
    { key: 'SR', value: 'Serbian' },
    { key: 'SS', value: 'Swati' },
    { key: 'ST', value: 'Southern Sotho' },
    { key: 'SU', value: 'Sundanese' },
    { key: 'SV', value: 'Swedish' },
    { key: 'SW', value: 'Swahili' },
    { key: 'TA', value: 'Tamil' },
    { key: 'TE', value: 'Telugu' },
    { key: 'TG', value: 'Tajik' },
    { key: 'TH', value: 'Thai' },
    { key: 'TI', value: 'Tigrinya' },
    { key: 'TK', value: 'Turkmen' },
    { key: 'TL', value: 'Tagalog' },
    { key: 'TN', value: 'Tswana' },
    { key: 'TO', value: 'Tonga' },
    { key: 'TR', value: 'Turkish' },
    { key: 'TS', value: 'Tsonga' },
    { key: 'TT', value: 'Tatar' },
    { key: 'TW', value: 'Twi' },
    { key: 'TY', value: 'Tahitian' },
    { key: 'UG', value: 'Uyghur' },
    { key: 'UK', value: 'Ukrainian' },
    { key: 'UR', value: 'Urdu' },
    { key: 'UZ', value: 'Uzbek' },
    { key: 'VE', value: 'Venda' },
    { key: 'VI', value: 'Vietnamese' },
    { key: 'VO', value: 'Volapük' },
    { key: 'WA', value: 'Walloon' },
    { key: 'WO', value: 'Wolof' },
    { key: 'XH', value: 'Xhosa' },
    { key: 'YI', value: 'Yiddish' },
    { key: 'YO', value: 'Yoruba' },
    { key: 'ZA', value: 'Zhuang' },
    { key: 'ZH', value: 'Chinese' },
    { key: 'ZU', value: 'Zulu' },
];

export const currencies: Array<IConstDict> = [
    { key: 'AED', value: 'AED' },
    { key: 'USD', value: 'USD' },
    { key: 'SAR', value: 'SAR' },
    { key: 'PKR', value: 'PKR' },
    { key: 'EGP', value: 'EGP' },
    { key: 'EUR', value: 'EUR' },
    { key: 'IQD', value: 'IQD', renderTenants: ['tenant1','tenant7_api', 'tenant37_api']},
    { key: 'QAR', value: 'QAR', renderTenants: ['tenant51_api']}
];

export const governorates: Array<IConstDict> = [
    { key: '1', value: 'Erbil' },
    { key: '2', value: 'Silemani' },
    { key: '3', value: 'Duhok' },
    { key: '4', value: 'Halabja' },
    { key: '5', value: 'Kirkuk' },
    { key: '6', value: 'Al Anbar' },
    { key: '7', value: 'Babil' },
    { key: '8', value: 'Baghdad' },
    { key: '9', value: 'Basra' },
    { key: '10', value: 'Al-Qadisiyyah' },
    { key: '11', value: 'Diyala' },
    { key: '12', value: 'Dhi Qar' },
    { key: '13', value: 'Salahaddin' },
    { key: '14', value: 'Karbala' },
    { key: '15', value: 'Muthanna' },
    { key: '16', value: 'Maysan' },
    { key: '17', value: 'Najaf' },
    { key: '18', value: 'Nineveh' },
    { key: '19', value: 'Wasit' },
];

export const cityTown: Array<IConstDict> = [
    { key: '1', value: 'Soran' },
    { key: '1', value: 'Rawanduz' },
    { key: '1', value: 'Koye' },
    { key: '1', value: 'Shaqlawa' },
    { key: '1', value: 'Erbil' },
    { key: '1', value: 'Khabat' },
    { key: '1', value: 'Makhmur' },
    { key: '2', value: 'Chamchamal' },
    { key: '2', value: 'Silemani' },
    { key: '2', value: 'Dokan' },
    { key: '2', value: 'Bazian' },
    { key: '2', value: 'Sharbazher' },
    { key: '2', value: 'Chwarqurna' },
    { key: '2', value: 'Khormal' },
    { key: '2', value: 'Piramagrun' },
    { key: '2', value: 'Arbat' },
    { key: '2', value: 'Penjwen' },
    { key: '2', value: 'Hawraman' },
    { key: '2', value: 'Sharazoor' },
    { key: '2', value: 'Darbandikhan' },
    { key: '2', value: 'Kalar' },
    { key: '2', value: 'Qaladza' },
    { key: '2', value: 'Ranya' },
    { key: '2', value: 'Saidsadiq' },
    { key: '3', value: 'Amedi' },
    { key: '3', value: 'Duhok' },
    { key: '3', value: 'Sumail' },
    { key: '3', value: 'Bardarash' },
    { key: '3', value: 'Zakho' },
    { key: '3', value: 'Akre' },
    { key: '4', value: 'Halabja' },
    { key: '5', value: 'Hawija' },
    { key: '5', value: 'Dibis' },
    { key: '5', value: 'Kirkuk' },
    { key: '5', value: 'Altun Kupri' },
    { key: '5', value: 'Daquq' },
    { key: '6', value: 'Khalidiya' },
    { key: '6', value: 'Heet' },
    { key: '6', value: 'Ramadi' },
    { key: '6', value: 'Al-Qaim' },
    { key: '6', value: 'Fallujah' },
    { key: '6', value: 'Rawa' },
    { key: '6', value: 'Anah' },
    { key: '6', value: 'Rutba' },
    { key: '6', value: 'Haditha' },
    { key: '7', value: 'Al Hashmiyah' },
    { key: '7', value: 'Al Qasim' },
    { key: '7', value: 'Al Midhatiya' },
    { key: '7', value: 'Al Iskandariya' },
    { key: '7', value: 'Latifiyah' },
    { key: '7', value: 'Hillah' },
    { key: '7', value: 'Yusufiyah' },
    { key: '7', value: 'Jurf Al Nasr' },
    { key: '7', value: 'Salman Pak' },
    { key: '7', value: 'Al Musayab' },
    { key: '7', value: 'Al Kifl' },
    { key: '7', value: 'Al Mahawil' },
    { key: '8', value: 'Kadhimiya' },
    { key: '8', value: 'Adhamiyah' },
    { key: '9', value: 'Basrah' },
    { key: '9', value: 'Al Faw' },
    { key: '9', value: 'Al Qurnah' },
    { key: '9', value: 'Al Zubair' },
    { key: '9', value: 'Al Midaina' },
    { key: '9', value: 'Abu Al-Khaseeb' },
    { key: '9', value: 'Shatt Al-Arab' },
    { key: '10', value: 'Hamza' },
    { key: '10', value: 'Al-Shamiya' },
    { key: '10', value: 'Afak' },
    { key: '10', value: 'Diwaniya' },
    { key: '11', value: 'Ba quba' },
    { key: '11', value: 'Al Khalis' },
    { key: '11', value: 'Hibhib' },
    { key: '11', value: 'Nahrawan' },
    { key: '11', value: 'Al Sadiyah' },
    { key: '11', value: 'Jalula' },
    { key: '11', value: 'Al-Muqdadiya' },
    { key: '11', value: 'Khanaqin' },
    { key: '11', value: 'Khalis' },
    { key: '11', value: 'Kifri' },
    { key: '11', value: 'Balad Ruz' },
    { key: '12', value: 'Al-Chibayish' },
    { key: '12', value: 'Al-Rifai' },
    { key: '12', value: 'Suq Al-Shuyukh' },
    { key: '12', value: 'Nasiriyah' },
    { key: '13', value: 'Tooz Khurmatu' },
    { key: '13', value: 'Al Shirqat' },
    { key: '13', value: 'Al Daur' },
    { key: '13', value: 'Tikrit' },
    { key: '13', value: 'Samarra' },
    { key: '13', value: 'Baiji' },
    { key: '13', value: 'Balad' },
    { key: '13', value: 'Dujail' },
    { key: '14', value: 'Karbala' },
    { key: '14', value: 'Ain Al-Tamur' },
    { key: '14', value: 'Al-Hindiya' },
    { key: '15', value: 'Rumaitha' },
    { key: '15', value: 'Samawah' },
    { key: '15', value: 'Salman' },
    { key: '15', value: 'Warka' },
    { key: '15', value: 'Al Khidhir' },
    { key: '16', value: 'Qal at Saleh' },
    { key: '16', value: 'Al Maimouna' },
    { key: '16', value: 'Majjar al Kabir' },
    { key: '16', value: 'Amarah' },
    { key: '16', value: 'Al-Kahla' },
    { key: '16', value: 'Ali Al-Gharbi' },
    { key: '17', value: 'Najaf' },
    { key: '17', value: 'Kufa' },
    { key: '17', value: 'Al Manathera' },
    { key: '17', value: 'Al-Meshkhab' },
    { key: '18', value: 'Bartella' },
    { key: '18', value: 'Tel Afar' },
    { key: '18', value: 'Sinjar' },
    { key: '18', value: 'Zummar' },
    { key: '18', value: 'Al-Hamdaniya' },
    { key: '18', value: 'Tel Kaif' },
    { key: '18', value: 'Al-Ba aj' },
    { key: '18', value: 'Mousel' },
    { key: '18', value: 'Bashiqa' },
    { key: '18', value: 'Shekhan' },
    { key: '19', value: 'Badra' },
    { key: '19', value: 'Numaniyah' },
    { key: '19', value: 'Al-Aziziyah' },
    { key: '19', value: 'Kut' },
    { key: '19', value: 'Al-Hai' },
    { key: '19', value: 'Suwaira' },
];

export const relationWithParent: Array<IConstDict> = [
    { key: 'SON', value: 'Son' },
    { key: 'DAUGHTER', value: 'Daughter' },
    { key: 'NEPHEW', value: 'Nephew' },
    { key: 'NIECE', value: 'Niece' },
    { key: 'HUSBAND', value: 'Husband' },
    { key: 'WIFE', value: 'Wife' },
    { key: 'FATHER', value: 'Father' },
    { key: 'MOTHER', value: 'Mother' },
    { key: 'EMPLOYEE', value: 'Employee' },
    { key: 'OTHER', value: 'Other' },
];

export const employmentTypes: Array<IConstDict> = [
    { key: 'SALARIED', value: 'Salaried' },
    { key: 'SELF_EMPLOYED', value: 'Self Employed' },
    { key: 'RETIRED', value: 'Retired' },
    { key: 'NOT_EMPLOYED', value: 'Not Employed' },
    { key: 'BUSINESS_OWNER', value: 'Business Owner' },
    { key: 'STUDENT', value: 'Student' },
    { key: 'HOMEMAKER', value: 'Homemaker' },
    { key: 'OTHER', value: 'Other' },
];
